


































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  saveLoading = false;
  importUrl: string = "";

  get headers() {
    return {
      "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie(),
      Authorization: "Bearer " + window.abp.auth.getToken(),
    };
  }

  created() {
    this.importUrl = `${XMLHTTP_BASEURL}/api/services/app/SystemBasic/ImportReportSql`;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  handleFormatError(file: any) {
    this.$Message.warning("请选择'xlsx'格式文件！");
  }

  handleSuccess() {
    this.$emit("input", false);
    this.$emit("on-success");
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/sqlMaintain/importData.vue